<template>
  <div class="modal fade" id="AnimalAddModal" ref="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" @click="close">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <div class="title-modal">
            <img :src="addanimal" />
            <h3>Ajouter un animal</h3>
          </div>

          <form class="mt-4" @submit.prevent="submitAnimal">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-9">
                <div class="d-flex gap-3 mb-4">
                  <div class="input-form">
                    <label class="label-control">Propriétaire*</label>
                    <select
                      v-model="form.proprietaireId"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': errors.proprietaireId }"
                      required
                    >
                      <option value="" disabled>Sélectionner un propriétaire</option>
                      <option v-for="owner in formattedProprietaires" :key="owner.id" :value="owner.id">
                        {{ owner.fullName }}
                      </option>
                    </select>
                    <div v-if="errors.proprietaireId" class="invalid-feedback">
                      {{ errors.proprietaireId }}
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">Nom*</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.name"
                      :class="{ 'is-invalid': errors.name }"
                      required
                    />
                    <div v-if="errors.name" class="invalid-feedback">
                      {{ errors.name }}
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-3 mb-4">
                  <div class="input-form">
                    <label class="label-control">Type d'animal*</label>
                    <select
                      v-model="form.animalTypeId"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': errors.animalTypeId }"
                      required
                    >
                      <option value="" disabled>Sélectionner un type</option>
                      <option v-for="type in filteredAnimalTypes" :key="type.id" :value="type.id">
                        {{ type.name }}
                      </option>
                    </select>
                    <div v-if="errors.animalTypeId" class="invalid-feedback">
                      {{ errors.animalTypeId }}
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">Race*</label>
                    <select
                      v-model="form.raceId"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': errors.raceId }"
                      required
                    >
                      <option value="">
                        {{ !form.animalTypeId ? "Sélectionner d'abord un type" : "Sélectionner une race" }}
                      </option>
                      <option v-for="race in filteredRaces" :key="race.id" :value="race.id">
                        {{ race.name }}
                      </option>
                    </select>
                    <div v-if="errors.raceId" class="invalid-feedback">
                      {{ errors.raceId }}
                    </div>
                  </div>
                </div>

                <div class="mb-4" v-if="form.animalTypeId">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="underAgeAdd" v-model="form.underAge" />
                    <label class="form-check-label" for="underAgeAdd">
                      {{ getUnderAgeLabel(form.animalTypeId) }}
                    </label>
                  </div>
                </div>

                <div class="d-flex gap-3 mb-4">
                  <div class="input-form">
                    <label class="label-control">Date de naissance</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="form.birthDate"
                      :class="{ 'is-invalid': errors.birthDate }"
                    />
                    <div v-if="errors.birthDate" class="invalid-feedback">
                      {{ errors.birthDate }}
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">Sexe</label>
                    <select
                      v-model="form.gender"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': errors.gender }"
                    >
                      <option value="" disabled>Sélectionner le sexe</option>
                      <option value="Mâle">Mâle</option>
                      <option value="Femelle">Femelle</option>
                    </select>
                    <div v-if="errors.gender" class="invalid-feedback">
                      {{ errors.gender }}
                    </div>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-4">
                  <div class="input-form">
                    <label class="label-control">Poids*</label>
                    <div class="number-input-wrapper">
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="form.weight"
                        step="0.1"
                        min="0"
                        max="999.9"
                        placeholder="0.0"
                        :class="{ 'is-invalid': errors.weight }"
                      />
                      <div class="arrows">
                        <button type="button" @click="updateWeight('increment', 'weight')">
                          <i class="ti ti-angle-up"></i>
                        </button>
                        <button type="button" @click="updateWeight('decrement', 'weight')" :disabled="form.weight <= 0">
                          <i class="ti ti-angle-down"></i>
                        </button>
                      </div>
                      <span class="unit">Kg</span>
                    </div>
                    <div v-if="errors.weight" class="invalid-feedback">
                      {{ errors.weight }}
                    </div>
                  </div>
                </div>
                <div v-if="errors.general" class="alert alert-danger">
                  {{ errors.general }}
                </div>
                <div class="d-flex justify-content-center gap-3 mt-3">
                  <button type="button" class="btn btn-outline-orange w-25" @click="close">Annuler</button>
                  <button type="submit" class="btn btn-orange w-25" :disabled="animauxStore.loading">
                    <span v-if="animauxStore.loading"> <i class="ti ti-loader"></i> Ajout... </span>
                    <span v-else>Valider</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import emitter from "@/event-bus";
  import addanimal from "@/assets/images/animal-add.svg";
  import { useAnimauxStore } from "@/stores/animauxStore";
  import { useProprietairesStore } from "@/stores/esupplyvet/proprietairesStore";

  export default {
    name: "AnimalAddModal",
    data() {
      return {
        addanimal,
        form: {
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          underAge: false,
        },
        errors: {},
        modalInstance: null,
      };
    },
    computed: {
      animauxStore() {
        return useAnimauxStore();
      },
      proprietairesStore() {
        return useProprietairesStore();
      },
      formattedProprietaires() {
        return this.proprietairesStore.formattedProprietaires || [];
      },
      filteredAnimalTypes() {
        const types = this.animauxStore.animalTypes || [];
        return types.filter(t => ["dog", "cat"].includes(String(t.slug || "").toLowerCase()));
      },
      filteredRaces() {
        if (!this.form.animalTypeId) return [];
        return this.animauxStore.getFilteredRaces(this.form.animalTypeId);
      },
    },
    watch: {
      "form.animalTypeId"(newTypeId, oldTypeId) {
        if (oldTypeId && newTypeId !== oldTypeId) {
          this.form.raceId = "";
        }
      },
    },
    mounted() {
      emitter.on("animal:add:open", this.open);
      this.forceVeterinaryContextForDelegates();
      this.ensureReferenceDataLoaded();
    },
    beforeUnmount() {
      emitter.off("animal:add:open", this.open);
    },
    methods: {
      forceVeterinaryContextForDelegates() {
        try {
          import("@/services/veterinaryTokenService").then(({ default: VeterinaryTokenService }) => {
            if (VeterinaryTokenService.isCurrentUserDelegate()) {
              VeterinaryTokenService.activateVeterinaryContext();
            }
          });
        } catch (error) {
          console.error("[AnimalAddModal] Erreur activation contexte vétérinaire:", error);
        }
      },

      async ensureReferenceDataLoaded() {
        const loaders = [];
        if (!this.proprietairesStore.proprietaires || this.proprietairesStore.proprietaires.length === 0) {
          loaders.push(this.proprietairesStore.fetchProprietaires?.());
        }
        if (!this.animauxStore.animalTypes || this.animauxStore.animalTypes.length === 0) {
          loaders.push(this.animauxStore.fetchAnimalTypes());
        }
        if (!this.animauxStore.allRaces || this.animauxStore.allRaces.length === 0) {
          loaders.push(this.animauxStore.fetchAnimalRaces());
        }
        await Promise.all(loaders);
      },

      open() {
        if (this.animauxStore.selectedProprietaireId) {
          this.form.proprietaireId = this.animauxStore.selectedProprietaireId.toString();
        } else if (!this.form.proprietaireId && this.formattedProprietaires.length === 1) {
          this.form.proprietaireId = this.formattedProprietaires[0].id.toString();
        }

        this.errors = {};

        this.$nextTick(() => {
          const el = this.$refs.modal;
          if (el) {
            try {
              const Modal = window.bootstrap?.Modal || (window.$ && window.$.fn?.modal);
              if (Modal && window.bootstrap?.Modal) {
                this.modalInstance = new window.bootstrap.Modal(el);
                this.modalInstance.show();
              } else {
                if (window.$ && window.$(el).modal) {
                  window.$(el).modal("show");
                } else {
                  el.style.display = "block";
                  el.classList.add("show");
                }
              }
            } catch (e) {
              console.warn("Bootstrap Modal indisponible, fallback utilisé", e);
              el.style.display = "block";
              el.classList.add("show");
            }
          }
        });
      },

      close() {
        const el = this.$refs.modal;
        try {
          if (this.modalInstance?.hide) {
            this.modalInstance.hide();
          } else if (window.$ && window.$(el).modal) {
            window.$(el).modal("hide");
          } else if (el) {
            el.classList.remove("show");
            el.style.display = "none";
          }
        } catch (e) {
          console.warn("Erreur fermeture modal", e);
        } finally {
          this.resetForm();
        }
      },

      resetForm() {
        this.form = {
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          underAge: false,
        };
        this.errors = {};
      },

      validateForm() {
        this.errors = {};
        let isValid = true;

        if (!this.form.proprietaireId) {
          this.errors.proprietaireId = "Le propriétaire est obligatoire";
          isValid = false;
        }

        if (!this.form.name.trim()) {
          this.errors.name = "Le nom est obligatoire";
          isValid = false;
        }

        if (!this.form.animalTypeId) {
          this.errors.animalTypeId = "Le type d'animal est obligatoire";
          isValid = false;
        }

        if (!this.form.raceId) {
          this.errors.raceId = "La race est obligatoire";
          isValid = false;
        }

        return isValid;
      },

      updateWeight(operation, field) {
        let value = Number(this.form[field] || 0);
        if (operation === "increment") {
          value = Math.min(value + 0.1, 999.9);
        } else if (operation === "decrement") {
          value = Math.max(value - 0.1, 0);
        }
        this.form[field] = Math.round(value * 10) / 10;
      },

      getUnderAgeLabel(animalTypeId) {
        if (!animalTypeId) return "Chiot/Chaton";
        const type = this.animauxStore.animalTypes.find(t => t.id === parseInt(animalTypeId));
        if (!type) return "Chiot/Chaton";
        const slug = String(type.slug || "").toLowerCase();
        if (slug === "dog") return "Chiot";
        if (slug === "cat") return "Chaton";
        return "Chiot/Chaton";
      },

      async submitAnimal() {
        if (!this.validateForm()) {
          return;
        }

        try {
          const payload = {
            name: this.form.name.trim(),
            birthDate: this.form.birthDate || null,
            gender: this.form.gender || null,
            weight: this.form.weight.toString(),
            underAge: !!this.form.underAge,
            animalTypeId: parseInt(this.form.animalTypeId),
            ownerId: parseInt(this.form.proprietaireId),
            raceId: parseInt(this.form.raceId),
          };
          this.animauxStore.selectedProprietaireId = payload.ownerId;
          const newAnimal = await this.animauxStore.addAnimal(payload);
          emitter.emit("animal:created", newAnimal);
          this.close();
        } catch (error) {
          console.error("Erreur lors de l'ajout de l'animal:", error);
          this.errors.general = "Erreur lors de l'ajout de l'animal";
        }
      },
    },
  };
</script>

<style scoped></style>
